/**
 * SEE-1846: Team members → edit, change a member's phone number. Served by the CDK v2-user
 * Lambda. Primary and Secondary admins of the member's company and support users; a Secondary
 * can't change a Primary's number, and nobody can change their own here (server-enforced).
 */
export const adminUpdateMemberPhoneMutation = /* GraphQL */ `
  mutation AdminUpdateMemberPhone($input: AdminUpdateMemberPhoneInput!) {
    adminUpdateMemberPhone(input: $input) {
      paidolUserId
      phoneNumber
    }
  }
`;
